<div class="loader-overlay" *ngIf="isLoading">
  <div class="loader"></div>
</div>
